import { action } from 'mobx';
import { createCustomPolicy } from 'ui/schedules/policy_entry/policy_entry_logic';
import { CustomPolicy } from 'services/pangolin/types';
import { ModalStore } from 'ui/base/modal';
import { BooleanStore, StringStore } from 'ui/base/input';


export class CustomInputStore {
  validator: (custom: string) => boolean;
  custom: StringStore;
  modal: ModalStore;
  isValid: BooleanStore;

  constructor(validator: (custom: string) => boolean) {
    this.custom = new StringStore('');
    this.modal = new ModalStore(false);
    this.isValid = new BooleanStore(true);
    this.validator = validator;
  }

  @action.bound
  commit(): CustomPolicy | undefined {
    if (this.validator(this.custom.value)) {
      this.isValid.setValue(true);
      return createCustomPolicy(this.custom.value);
    } else {
      this.isValid.setValue(false);
      return undefined;
    }
  }

  @action.bound
  showModal() {
    this.custom.setValue('');
    this.isValid.setValue(true);
    this.modal.showModal();
  }

  @action.bound
  hideModal() {
    this.modal.hideModal();
  }

  @action.bound
  toggleModal() {
    this.modal.visible = !this.modal.visible;
  }
}
